import { apiSlice } from "../apiSlice";
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PROD;
export interface ItemMenu {
  displayName: string;
  price: number;
  itemId: string;
  itemType: string;
}

export interface CreateMenuRequest {
  restaurantId: string;
  displayName: string;
  dineType: string;
  servingTime: string;
  brand: "Curry King" | "Wok & Flame" | "Rasa Bath";
  items: ItemMenu[];
  supportedApps?: string[];
}

export interface DeleteMenuRequest {
  restaurantId: string;
  menuId: string;
}

export interface UpdateMenuRequest {
  restaurantId: string;
  menuId: string;
  brand: "Curry King" | "Wok & Flame" | "Rasa Bath";
  displayName: string;
  dineType: string;
  servingTime: string;
  items: ItemMenu[];
  supportedApps?: string[];
}

export interface Menus {
  menuId: string;
  orderNumber: number;
}

export interface UpdateMenuListOrderRequest {
  restaurantId: string;
  displayOrder: Menus[];
}

export const MenusService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createMenu: builder.mutation<any, CreateMenuRequest>({
      query: (data) => ({
        url: `https://adminhttps-createtmenu${API_BASE_DOMAIN}`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),
    getMenuList: builder.query({
      query: (restaurantId) =>
        `https://adminhttps-getmenulistbyrestaurantid${API_BASE_DOMAIN}?restaurantId=${restaurantId}`,
    }),
    deleteMenu: builder.mutation<any, DeleteMenuRequest>({
      query: (data: DeleteMenuRequest) => ({
        url: `https://adminhttps-deletemenu${API_BASE_DOMAIN}/`,
        method: "DELETE",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),
    updateMenu: builder.mutation<any, UpdateMenuRequest>({
      query: (data: UpdateMenuRequest) => ({
        url: `https://adminhttps-updatemenu${API_BASE_DOMAIN}`,
        method: "PUT",
        body: data,
      }),
    }),
    getMenuItemsList: builder.query({
      query: ({ restaurantId, menuType }) =>
        `https://adminhttps-getmenuitemsbyrestaurantidformenu${API_BASE_DOMAIN}/?restId=${restaurantId}&menuType=${menuType}`,
    }),
    updateMenuListOrder: builder.mutation<any, UpdateMenuListOrderRequest>({
      query: (data: any) => ({
        url: `https://adminhttps-updatemenuListdisplayorder${API_BASE_DOMAIN}`,
        method: "PUT",
        body: data,
      }),
    }),
  }),
});

export const {
  useCreateMenuMutation,
  useGetMenuListQuery,
  useLazyGetMenuListQuery,
  useDeleteMenuMutation,
  useUpdateMenuMutation,
  useGetMenuItemsListQuery,
  useLazyGetMenuItemsListQuery,
  useUpdateMenuListOrderMutation,
} = MenusService;
